import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import { strictFetcher } from './strict-fetcher'

/// One row of `GET /alkane/top-traders` — recent pool-swap volume, valued at
/// today's mids (the server labels it `basis: "current-price"`; a ranking,
/// not PnL) and signed by the tx's first-input signer.
export interface TopTrader {
	address: string
	volume_sats: number
	volume_usd: number | null
	trades: number
}

interface TopTradersBody {
	hours: number
	basis: string
	traders: TopTrader[]
}

export default function useTopTraders(): {
	traders: TopTrader[]
	unavailable: boolean
	isLoading: boolean
} {
	const { data, error, isLoading } = useSwr<TopTradersBody>(
		`${API_URL}/alkane/top-traders`,
		strictFetcher,
		{ refreshInterval: 300_000, revalidateOnFocus: false }
	)
	return {
		traders: Array.isArray(data?.traders) ? data!.traders : [],
		unavailable: error !== undefined,
		isLoading
	}
}
